"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var NoteFilled = function NoteFilled() {
  return _react["default"].createElement("path", {
    d: "m3.1816 0a3.182 3.182 0 0 0-3.1816 3.1816v0.81836 6 0.81836a3.182 3.182 0 0 0 3.1816 3.1816h0.81836 6 0.81836a3.182 3.182 0 0 0 3.1816-3.1816v-0.81836-6-0.81836a3.182 3.182 0 0 0-3.1816-3.1816h-0.81836-6-0.81836zm0.14453 4.582h7.3477c0.431 0 0.7793 0.35688 0.7793 0.79688 0 0.438-0.3483 0.79492-0.7793 0.79492h-7.3477c-0.431 0-0.7793-0.35692-0.7793-0.79492a0.788 0.788 0 0 1 0.7793-0.79688zm-0.10938 3.1816h6.2949c0.37 0 0.66992 0.35492 0.66992 0.79492s-0.29797 0.79688-0.66797 0.79688h-6.2969c-0.37 0-0.66992-0.35688-0.66992-0.79688 0-0.439 0.29992-0.79492 0.66992-0.79492z"
  });
};

var _default = (0, _createSvgIcon["default"])(NoteFilled, {
  viewBox: viewBox
});

exports["default"] = _default;